





















import PublicPageContent from '@/components/PublicPageContent.vue'
import WithThemeTitle from '@/components/WithThemeTitle.vue'
import { isPosteTheme } from '@/components/RenderWithTheme.vue'

export default {
  components: { WithThemeTitle, PublicPageContent },
  props: {
    isSending: { type: Boolean, required: true }
  },
  computed: {
    classes() {
      return {
        'password-setup-link-expired__button': true,
        'password-setup-link-expired__button--loading': this.isSending
      }
    },
    isPosteTheme() {
      return isPosteTheme
    }
  }
}
